import { duration, easing } from "../motion";

/**
 * Semantic motion roles — intent-based duration/easing pairs for UI transitions.
 * No raw timing literals; all values resolve through primitive motion tokens.
 */
export const motion = {
  hover: {
    duration: duration.fast,
    easing: easing.standard,
  },
  focus: {
    duration: duration.fast,
    easing: easing.sharp,
  },
  enter: {
    duration: duration.normal,
    easing: easing.decelerate,
  },
  exit: {
    duration: duration.fast,
    easing: easing.accelerate,
  },
} as const;

export type TMotionSemantic = typeof motion;
